module.exports = {"connectProblem":"Čeká se na připojení..."}